/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const CDS_SIDEBAR_RESET_CHROME_EVENT = 'cds-reset-pinned-sidebar-chrome';

export const CDS_SIDEBAR_PIN_STORAGE_PREFIX = 'cdsPinnedSidebarPin:';

export const CDS_SIDEBAR_RAIL_WIDTH_PX = 77;

export const CDS_SIDEBAR_DESKTOP_SUBMENU_WIDTH_PX = 280;

export const CDS_SIDEBAR_MOBILE_NAV_WIDTH_PX = 267;
